import { StageFrontFullLogoIcon, StageFrontOnlyLogoIcon } from "@src/assets/general-icons";
import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./FiltersPanel.module.scss";
import { PanelToggleButton } from "@src/components/panelToggleButton/PanelToggleButton";
import { PricingHeader } from "@src/components/header/components/pricingHeader/PricingHeader";
import { SalesHeader } from "@src/components/header/components/salesHeader/SalesHeader";
import { EventListHeader } from "@src/components/header/components/eventListHeader/EventListHeader";
import { PasswordManagerHeader } from "@src/components/header/components/passwordManagerHeader/passwordManagerHeader";
import { NewPoHeader } from "@src/components/header/components/newPoHeader/NewPoHeader";

interface IFiltersPanelProps {
	isExpanded: boolean;
	toggleExpanded: () => void;
}

const getPanelKey = (segment: string) => {
	if (!segment) return "inventory";
	return segment.replace(/-([a-z])/g, (_match, letter: string) => letter.toUpperCase());
};

const PANEL_ROUTES = ["inventory", "sales", "eventvue", "passwordManager", "newPo"];

export const routeHasFilterPanel = (pathname: string): boolean =>
	PANEL_ROUTES.includes(getPanelKey(pathname.split("/").filter(Boolean)[0] ?? ""));

export const FiltersPanel: React.FC<IFiltersPanelProps> = ({ isExpanded, toggleExpanded }) => {
	const { pathname } = useLocation();
	const primarySegment = pathname.split("/").filter(Boolean)[0] ?? "";

	const panelVariants: Record<string, React.ReactNode> = {
		inventory: <PricingHeader />,
		sales: <SalesHeader />,
		eventvue: <EventListHeader />,
		passwordManager: <PasswordManagerHeader />,
		newPo: <NewPoHeader />,
	};

	const panelContent = panelVariants[getPanelKey(primarySegment)];
	const hasPanel = routeHasFilterPanel(pathname);

	return (
		<aside className={styles.root} data-is-expanded={isExpanded}>
			<div className={styles.brand}>
				{isExpanded ? <StageFrontFullLogoIcon /> : <StageFrontOnlyLogoIcon />}
				{hasPanel ? (
					<PanelToggleButton onClick={toggleExpanded} ariaLabel={isExpanded ? "Collapse filters" : "Expand filters"} />
				) : null}
			</div>

			{panelContent ? (
				<div className={styles.content} data-is-hidden={!isExpanded}>
					{panelContent}
				</div>
			) : null}
		</aside>
	);
};
